import React from 'react';
import LabelText from '../../ui/LabelText';
import LabelNumber from '../../styled-components/LabelNumber';
import { MatchBasicDetails } from '../../pages/Chemistry/Utils';

interface PossessionValuesAndContentProps {
  matchBasicDetails?: MatchBasicDetails | null;
}

const PossessionValuesAndContent: React.FC<PossessionValuesAndContentProps> = ({
  matchBasicDetails
}) => {
  if (!matchBasicDetails) return null;

  const matchDate = new Date(matchBasicDetails.dateTime);

  const getOrdinalSuffix = (day: number): string => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const day = matchDate.getDate();
  const month = matchDate.toLocaleDateString("en-GB", { month: "long" });
  const year = matchDate.getFullYear();
  const formattedDate = `${day}${getOrdinalSuffix(day)} ${month} ${year}`;

  const label = matchBasicDetails?.label || "";
  const commaIndex = label.lastIndexOf(",");
  const teams = label.substring(0, commaIndex);
  const score = label.substring(commaIndex + 1).trim();
  const displayLabel = teams.length > 25 ? `${teams}\n${score}` : label;

  return (
    <div className='bottom-container' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '40px' }}>
      <div style={{ width: '1065px' }}>
        <div className="py-2">
          <div className="px-4 py-6 rounded relative overflow-hidden">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '24px', marginBottom: '16px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img
                  src={matchBasicDetails.homeTeam.teamUrl}
                  alt={`${matchBasicDetails.homeTeam.teamName} logo`}
                  style={{ width: '60px', height: '60px', objectFit: 'contain' }}
                />
              </div>

              <LabelText className="secondary-cta-text" style={{ fontWeight: 'bold', fontSize: '18px' }}>VS</LabelText>

              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img
                  src={matchBasicDetails.awayTeam.teamUrl}
                  alt={`${matchBasicDetails.awayTeam.teamName} logo`}
                  style={{ width: '60px', height: '60px', objectFit: 'contain' }}
                />
              </div>
            </div>

            <div style={{ textAlign: 'center' }}>
              <div style={{ marginBottom: '4px' }}>
                <LabelText className="secondary-cta-text" style={{
                  fontSize: '16px',
                  lineHeight: '1.5',
                  whiteSpace: 'pre-line',
                  fontWeight: '600'
                }}>
                  {displayLabel}
                </LabelText>
              </div>
              <div>
                <LabelNumber className='valuegraph-toggle-text' style={{ fontSize: '14px' }}>
                  {formattedDate}
                </LabelNumber>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PossessionValuesAndContent;